<template>
  <div class="login-register">
    <link href="static/css/pages/login-register-lock.css" rel="stylesheet">
    <div class="login-box card">
      <div class="card-body">
        <p class=""><img src="../assets/achiev-logo.svg" alt="homepage" class="dark-logo" /></p>

        <div class="form-horizontal form-material">
          <h3 class="box-title m-b-20">{{ $t("Change password") }}</h3>
          <div class="form-group " v-bind:class="{'has-danger': passwordError}">
            <small class="text-danger" v-for="problem in passwordProblems">
              {{ problem }} <br>
            </small>

            <div class="col-xs-12">
              <input class="form-control" type="password" v-model="password" :placeholder="$t('Password')">
              <small class="form-control-feedback" v-show="passwordError">Password incorrect</small>
            </div>
          </div>
          <div class="form-group" v-bind:class="{'has-danger': passwordError}">
            <div class="col-xs-12">
              <input class="form-control" type="password" v-model="passwordRepeat" :placeholder="$t('Repeat password')">
              <small class="form-control-feedback" v-show="passwordError">{{ $t("Password incorrect") }}</small>
            </div>
          </div>
        </div>
        <div class="form-group text-center">
          <div class="col-xs-12 p-b-20">
            <small v-show="resetSuccessful">{{ $t("Password reset successfully") }}</small>
            <button class="btn btn-block btn-lg btn-info btn-rounded" v-on:click="setNewPassword">{{ $t("Change password") }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ResetPassword",
    data: function() {
      return {
        passwordError: false,
        password: "",
        passwordRepeat: "",
        resetSuccessful: false,
        passwordProblems: []
      }
    },
    methods: {
      setNewPassword: function () {
        let vm = this;
        fetch(__API__ + "/api/user/reset", {
          body: JSON.stringify({
            "uid": this.$route.params.user_id,
            "token": this.$route.params.token,
            "password": this.password,
            "password_confirm": this.passwordRepeat
          }),
          method: "PATCH",
          headers: {
            Authorization: "Bearer " + this.$route.params.token,
            'content-type': 'application/json'
          }
        }).then(function (response) {
          if (response.status === 200) {
            vm.resetSuccessful = true;
            vm.$router.push("/login");
          }else{
            return response.json();
          }
        }).then(function (data) {
          vm.passwordProblems = [];
          let errors = data.title;
          for (let error in errors) {
            if (errors.hasOwnProperty(error)) {
              for (let i = 0; i < errors[error].length; i++) {
                vm.passwordProblems.push(errors[error][i]);
              }
            }
          }
        });
      }
    }
  }
</script>

<style scoped>
  .login-register{
    background: url("/static/img/login.jpg") no-repeat;
    background-size: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/ResetPassword.vue